import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const LeftMessageBubble = (props) => (
  <div className="message from-other">
    <p className="message-time-stamp">
      {moment(props.message.timestamp).format('LT')}
    </p>
    <p className="message-body">{props.message.body}</p>
  </div>
);

LeftMessageBubble.propTypes = {
  message: PropTypes.object,
};

export default LeftMessageBubble;
